// Subset of ReportPurchaseOrderLineItemColumnName from ReportingService

export enum CostOfGoodsSoldReportTableGroupingColumnId {
  AuditDateTime = 'auditDateTime',
  PurchaseOrderId = 'purchaseOrderId',
  TicketGroupId = 'ticketGroupId',
  PreviousCurrencyCode = 'previousCurrencyCode',
  PreviousIsActive = 'previousIsActive',
  CurrencyCode = 'currencyCode',
  IsActive = 'isActive',
  AdjustmentType = 'adjustmentType',
  AuditMonth = 'auditMonth',
  AuditWeek = 'auditWeek',
  AuditDay = 'auditDay',
}

export enum CostOfGoodsSoldReportTableValueColumnId {
  PreviousUnitCost = 'previousUnitCost',
  UnitCost = 'unitCost',
  UnitCostChangeInCurrentCurrency = 'unitCostChangeInCurrentCurrency',
  PreviousTotalCost = 'previousTotalCost',
  TotalCost = 'totalCost',
  TotalCostChangeInCurrentCurrency = 'totalCostChangeInCurrentCurrency',
  PreviousNumberOfTickets = 'previousNumberOfTickets',
  NumberOfTickets = 'numberOfTickets',
  NumberOfTicketsChange = 'numberOfTicketsChange',
}

export const COST_OF_GOODS_SOLD_REPORT_TABLE_FORMULA_COLUMNS: CostOfGoodsSoldReportTableValueColumnId[] =
  Object.values(CostOfGoodsSoldReportTableValueColumnId);
